module.exports = __webpack_public_path__ + "media/images/common/menu_white-b7a3ddbf7b961f4349c801a45f8118f9.png";